module.exports = __webpack_public_path__ + "static/media/ftl.986068c7.png";